import React, { useState } from "react";
// import Footer from "../components/Layout/Footer";
// import Header from "../components/Layout/Header";
// import styles from "../styles/styles";

const FAQPage = () => {
        const [activeTab, setActiveTab] = useState(0);

        const toggleTab = (tab) => {
            if (activeTab === tab) {
                setActiveTab(0);
            } else {
                setActiveTab(tab);
            }
        };
        return (
            <>
                <div className={` w-full  h-auto pt-28 bg-no-repeat bg-cover bg-fixed mx-auto px-10 py-6 `}>
                    <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">FAQ's</h2>
                    <div className="mx-auto space-y-4">
                        {/* single Faq */}

                        <div className="border-b border-gray-200 pb-4">
                            <button
                                className="flex items-center justify-between w-full"
                                onClick={() => toggleTab(2)}
                            >
                                <span className="text-lg font-medium text-gray-900">
                                What you need to get started for the ui ux design or website design or dashboard design or mobile app ui ux design?
                                </span>
                                {activeTab === 2 ? (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                )}
                            </button>
                            {activeTab === 2 && (
                                <div className="mt-4">
                                    <p className="text-base text-gray-500">
                                    Do you have references of competitors and inspirations? 2- Do you have Low fidelity wireframes or any hand sketches on white paper about your idea? 3- Do you have any documents ready for it? 4- Do you have a logo or specific colors or a brand guide? 5- How many pages/screens you need design?
                                    </p>
                                </div>
                            )}
                        </div>

                        <div className="border-b border-gray-200 pb-4">
                            <button
                                className="flex items-center justify-between w-full"
                                onClick={() => toggleTab(3)}
                            >
                                <span className="text-lg font-medium text-gray-900">
                                Do you have developers as well?
                                </span>
                                {activeTab === 3 ? (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                )}
                            </button>
                            {activeTab === 3 && (
                                <div className="mt-4">
                                    <p className="text-base text-gray-500">
                                    Yes, We have Full-Stack developers as well. Our Team Have top senior Developers of all time with latest technologies.
                                    </p>
                                </div>
                            )}
                        </div>

                        <div className="border-b border-gray-200 pb-4">
                            <button
                                className="flex items-center justify-between w-full"
                                onClick={() => toggleTab(4)}
                            >
                                <span className="text-lg font-medium text-gray-900">
                                Are you working with Wordpress, Shopify, Wix, Woocommerce?
                                </span>
                                {activeTab === 4 ? (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                )}
                            </button>
                            {activeTab === 4 && (
                                <div className="mt-4">
                                    <p className="text-base text-gray-500">
                                    Yes, We are working in Web Development, WordPress, Shopify, wix and Woocommerce etc.
                                    </p>
                                </div>
                            )}
                        </div>

                        <div className="border-b border-gray-200 pb-4">
                            <button
                                className="flex items-center justify-between w-full"
                                onClick={() => toggleTab(5)}
                            >
                                <span className="text-lg font-medium text-gray-900">
                                How many revisions you provide for the Web design Project?
                                </span>
                                {activeTab === 5 ? (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                )}
                            </button>
                            {activeTab === 5 && (
                                <div className="mt-4">
                                    <p className="text-base text-gray-500">
                                    I provide unlimited revision until you are happy and full-time support for the design
                                    </p>
                                </div>
                            )}
                        </div>

                        <div className="border-b border-gray-200 pb-4">
                            <button
                                className="flex items-center justify-between w-full"
                                onClick={() => toggleTab(6)}
                            >
                                <span className="text-lg font-medium text-gray-900">
                                Did you think meeting is part of our project for discussion the Web design points?
                                </span>
                                {activeTab === 6 ? (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                )}
                            </button>
                            {activeTab === 6 && (
                                <div className="mt-4">
                                    <p className="text-base text-gray-500">
                                    If you think meeting is part of our project then please mention in the requirements of order page and it's a part of our project
                                    </p>
                                </div>
                            )}
                        </div>

                        <div className="border-b border-gray-200 pb-4">
                            <button
                                className="flex items-center justify-between w-full"
                                onClick={() => toggleTab(7)}
                            >
                                <span className="text-lg font-medium text-gray-900">
                                Did you offer Web & Mobile UX/UI Website / webpage UI Landing Page UI Web application UI Dashboard UI Google Material Graphic design?
                                </span>
                                {activeTab === 7 ? (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                )}
                            </button>
                            {activeTab === 7 && (
                                <div className="mt-4">
                                    <p className="text-base text-gray-500">
                                    Yes we're offering all of them :) Did you offer Web & Mobile UX/UI Website / webpage UI Landing Page UI Web application UI Dashboard UI Google Material Graphic design User Interaction E-commerce ui design iOS and Android guidelines Graphic Design
                                    </p>
                                </div>
                            )}
                        </div>

                        <div className="border-b border-gray-200 pb-4">
                            <button
                                className="flex items-center justify-between w-full"
                                onClick={() => toggleTab(8)}
                            >
                                <span className="text-lg font-medium text-gray-900">
                                    What payment methods do you accept?
                                </span>
                                {activeTab === 8 ? (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="h-6 w-6 text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                )}
                            </button>
                            {activeTab === 8 && (
                                <div className="mt-4">
                                    <p className="text-base text-gray-500">
                                        We accept visa,mastercard,paypal payment method also we have
                                        cash on delivery system.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    };


    export default FAQPage;
